// ResponsiveRendezVous.jsx → src/gestion-rendezvous/
import React from "react";
import GestionRendezVous from "./GestionRendezVous";
import AppointmentsMobile from "../mobile/produits/AppointmentsMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveRendezVous(props) {
  return useIsMobile() ? <AppointmentsMobile {...props} /> : <GestionRendezVous {...props} />;
}
